import React from 'react'
import {makeStyles} from '@mui/styles';
import {Avatar, Box, Divider, TextField} from '@mui/material';
import CardMenu from '../../../Toolbar/Menu/CardMenu';
import UploadImage from './UploadImage';


const useStyles = makeStyles(theme => ({
    background:{
        backgroundColor: '#f5f5f5'
    },
    details: {
        textAlign: 'center',
    },
    fill:{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    avatar: {
        margin: '30px',
        width: '90px',
        height: '90px',
    },
    avatarContainer: {
        position: 'relative',
        margin: '30px',
        width: '90px',
        height: '90px',
    },
    dataInput:{
        width:'90%'
    }
}));


export default function EditUserFSBig({commands,user, edit, uploadImage}) {
    const classes = useStyles();

    return (
        <div>
            <Divider/>
            <Box className={classes.background} display="flex">
                <Box className={classes.fill}>
                    <div className={classes.avatarContainer}>
                        <Avatar alt={user.username} src={user.imageData} className={classes.avatar} style={{position: 'absolute', top: 0, left: 0}} />
                        <UploadImage currentImage={user.imageData} saveImage={uploadImage} />
                    </div>
                </Box>
                <Box className={classes.details} flexGrow={1} display="flex" flexDirection="column">
                    <Box >
                        <TextField className={classes.dataInput} label='UserName' defaultValue={user.username}
                                   onChange={(e)=> edit({username:e.target.value})}/>
                    </Box>
                    <Box>
                        <TextField className={classes.dataInput} multiline label='About' defaultValue={user.about}
                                   onChange={(e)=> edit({about:e.target.value})}/>
                    </Box>
                </Box>
                <Box className={classes.fill}>
                    <CardMenu commands={commands} recipe={user} />
                </Box>
            </Box>
        </div>
    )
}
